<template>
    <div class="metodological-file" v-if="items != undefined">
      <button
        @click="Show_Dropdown()"
        class="metodological-file__button"
      >
        {{ title_static }}
      </button>
      <div :class="[{'metodological-file__dropdown-show': show}, 'metodological-file__dropdown']">
        <a
          class="metodological-file__item"
          v-for="(item, index) in items"
          :key="index"
        >
          <img
            :id="item.id"
            :src="Get_Image(item.src)"
            @click="Change_Page(item.route), Change_Index(index)"
            @mouseover="Change_Src(item.src_hover,item.id); title_static=item.title"
            @mouseleave="Change_Src(item.src,item.id); title_static=title"
          />
        </a>
      </div>
    </div>
  </template>

  <script>
  import { mapActions } from 'vuex'
  export default {
    name: 'MetodologicalFileDropdown',

    data () {
      return {
        show: true,
        title_static: this.title
      }
    },

    props: {
      items: Object,

      title: {
        default: 'Fichas Metodológicas',
        type: String
      }
    },

    methods: {
    ...mapActions(['Change_Index']),

      Get_Image (src) {
        return (require(`../../assets/images/cards/${src}`))
      },
      Show_Dropdown () {
        this.show = !this.show
      },
      Change_Src (change, id) {
        document.getElementById(id).src = (require(`../../assets/images/cards/${change}`))
      },
      Change_Page (route) {
        this.$router.push(route)
      }
    }
  }
  </script>

  <style scoped>
  .metodological-file {
    display: flex;
    border: 0.1rem solid rgb(177, 177, 177);
    justify-content: center;
    flex-flow: row wrap;
    width: 90%;
  }
  .metodological-file__button {
    background-color: rgba(85, 85, 85, 0.8);
    border: none;
    color: white;
    cursor: pointer;
    font-family: "Ancizar-bold", Helvetica, Arial;
    padding: 1rem 2rem;
    height: 5rem;
    width: 100%;
  }
  .metodological-file__dropdown {
    display: flex;
    flex-direction: column;
    max-height: 0;
    overflow-y: auto;
    width: 100%;
    transition: max-height .5s;
  }
  .metodological-file__dropdown-show {
    max-height: 20rem;
    transition: max-height .5s;
  }
  .metodological-file__item {
    min-width: 100%;
    display: flex;
    justify-content: center;
    margin: 1rem 0;
  }
  img {
    cursor: pointer;
    width: 6rem;
    height: 6rem;
  }
  </style>